import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { switchToHijackerUser } from 'store';
import { UiButton, UiIcon, UiLabel } from 'ui-components';
import { StyledHijackTopbar } from './HijackTopbar.styles';

const empty = {};

export function HijackTopbar() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isSidebarMenuExpanded = useSelector(
    (state) => state.pageReducer.isSidebarMenuExpanded
  );
  const currentUser =
    useSelector((state) => state.accountReducer.currentUser?.user) || empty;

  const handleSwitchToHijackerUser = () => {
    dispatch(switchToHijackerUser());
  };

  return (
    <StyledHijackTopbar>
      <div
        className={classNames(
          'hijack-topbar',
          isSidebarMenuExpanded && 'is-sidebar-menu-expended'
        )}
      >
        <div className='sidebar'></div>
        <div className='main'>
          <div className='flex center'>
            <UiIcon
              className='info-icon'
              icon='ri-information-line'
              size={30}
              color='#ffffff'
            />
            <UiLabel>
              {t('users:yourAreViewingHijackedUserPanel', {
                fullName: [currentUser.name, currentUser.last_name]
                  .filter(Boolean)
                  .join(' '),
              })}
            </UiLabel>
          </div>
          <UiButton
            className='exit-button'
            color='secondary'
            onClick={handleSwitchToHijackerUser}
          >
            {t('users:exit')}
          </UiButton>
        </div>
      </div>
    </StyledHijackTopbar>
  );
}
